import script from "./TestimonialCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonialCard.vue?vue&type=script&setup=true&lang=js"

import "./TestimonialCard.vue?vue&type=style&index=0&id=72f962d3&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72f962d3"]])

export default __exports__